import { setMessage } from "../store/Slice/messageSlice";

const error = (error, thunkAPI) => {
  const message =
    (error.response && error.response.data && error.response.data.message) ||
    error.message ||
    error.toString();
  thunkAPI.dispatch(setMessage(message));
  return thunkAPI.rejectWithValue();
};
const errorSlice = {
  error,
};

export default errorSlice;
